import React, { useEffect } from "react"

import { Navigate, useSearchParams } from "react-router-dom"

import { GENERAL_CONFIG } from "./config/general.config"
import { ROUTES_CONFIG } from "./config/routes.config"
import { useAppDispatch } from "./store/appDispatch.hook"
import { useAppSelector } from "./store/selectors/app.selector"
import { runtimeSelector } from "./store/selectors/runtime.selector"
import { runtimeCheckUserIsLoggedIn } from "./store/thunks/runtime.thunks"

export const PublicRoute: React.FunctionComponent<IRouteProps> = ({
    children,
}) => {
    const [searchParams] = useSearchParams()

    const dispatch = useAppDispatch()

    const { isLoggedIn } = useAppSelector(runtimeSelector)

    useEffect(() => {
        dispatch(runtimeCheckUserIsLoggedIn())
    }, [])

    if (isLoggedIn === null) {
        return null
    }

    return !isLoggedIn ? (
        <>{children}</>
    ) : (
        <Navigate
            replace
            to={
                // Handle redirectTo from url query
                searchParams.get(
                    GENERAL_CONFIG.urlSearchParamsKeys.redirectTo,
                ) || ROUTES_CONFIG.baseApplicationUrl
            }
        />
    )
}

export const PrivateRoute: React.FunctionComponent<IRouteProps> = ({
    children,
}) => {
    const dispatch = useAppDispatch()

    const { isLoggedIn } = useAppSelector(runtimeSelector)

    useEffect(() => {
        dispatch(runtimeCheckUserIsLoggedIn())
    }, [])

    if (isLoggedIn === null) {
        return null
    }

    const getRedirectSearchParams = () => {
        const searchParams = new URLSearchParams()

        searchParams.set(
            GENERAL_CONFIG.urlSearchParamsKeys.redirectTo,
            `${window.location.pathname}${window.location.search}`,
        )

        return searchParams.toString()
    }

    return isLoggedIn ? (
        <>{children}</>
    ) : (
        <Navigate
            replace
            to={`${ROUTES_CONFIG.loginUrl}?${getRedirectSearchParams()}`}
        />
    )
}

interface IRouteProps {
    children?: React.ReactNode
}
